<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="newsCenter">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="">
						<span @click="toTopImg()">{{ $t('nav.home') }}</span>
						<span class="arrow">></span>
						<span>{{ $t('nav.copyright') }}</span>
					</div>
				</div>
				<div class="main">
					<div v-html="formatRichText(text)" class="rich"></div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="newsCenter">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt=""> <span @click="toTopImg()"
							style="cursor: pointer;">{{ $t('nav.home') }}</span>
						<span style="color: black;">></span><span>{{ $t('nav.copyright') }}</span>
					</div>
				</div>
				<!-- <div class="navigation"></div> -->
				<div class="main">
					<div v-html="formatRichText(text)"></div>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
	import {
		singleinfo
	} from '../api/api'
	export default {
		name: 'aboutUsTemplate',
		data() {
			return {
				text: ''
			}
		},
		created() {
			document.documentElement.scrollTop = 0;
			this.getSingleinfo() //二级菜单数组
			this.$bus.$on('localeChanged', this.getSingleinfo)
		},
		beforeDestroy() {
			this.$bus.$off('localeChanged', this.getSingleinfo)
		},
		watch: {

		},
		methods: {
			getSingleinfo() {
				singleinfo(18).then(res => {
					this.text = res.data.content
				})
			},
			//首页
			toTopImg() {
				this.$router.push({
					path: '/home',
					query: {
						index: 0
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.device-mobile {
		.newsCenter {
			width: 100vw;
			// display: flex;
			justify-content: center;
			background: #fff;
			padding-bottom: 50px;
			
			.navigation {
				width: 100%;
				background: #F5F5F5;
				padding: 0 0.333333rem;
				.navigationItem {
					display: flex;
					align-items: center;
					padding-top: 0.36rem;
					// height: 1.066667rem;
					color: #1979b7;
					font-size: 0.333333rem;
					.arrow {
						color: #030303;
						margin: 0 0.133333rem;
					}
					img {
						width: 0.333333rem;
						height: 0.333333rem;
						margin-right: 0.133333rem;
					}
				}
			}
		}
	
		.main {
			.rich {
				width: 9.466667rem;
				margin: 0 auto;
				font-size: 0.213333rem;
			}
	
		}
	
		
	}
	
	.device-pc {
		.newsCenter {
			width: 100vw;
			// display: flex;
			justify-content: center;
			background: #fff;
			padding-bottom: 50px;
		}

		.main {
			// display: flex;
			width: 1300px;
			margin: 0 auto;

			// padding-top: 47px;

		}

		.navigation {
			// width: 1210px;
			width: 100vw;
			background: #F5F5F5;
			// margin: 0 auto;
			// font-size: 16px;
			// font-weight: 400;
			// color: #545454;

			.navigationItem {
				width: 1300px;
				margin: 0 auto;
				display: flex;
				align-items: center;
				// margin-top: 15px;
				height: 36px;
				line-height: 36px;
				margin-bottom: 20px;

				color: #1979b7;
			}

			img {
				width: 20px;
				height: 20px;
				margin-right: 7px;

			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/copyright.vue